import {
  addElementActionHandlerMap,
  canvasActionHandlerMap,
  elementActionHandlerMap,
  groupActionHandlerMap,
  sharedActionHandlerMap,
} from "@/adaptors/StageActionAdaptors";
import contextMenuActionRegistry from "./ContextMenuActionRegistry";

/**
 * Register all stage-related context menu actions with the action registry
 * This should be called once during application startup
 */
export const registerStageActions = () => {
  contextMenuActionRegistry.registerActions(sharedActionHandlerMap, {
    category: "shared",
    description: "Actions available across multiple contexts",
  });

  // Register canvas/block actions
  contextMenuActionRegistry.registerActions(canvasActionHandlerMap, {
    category: "canvas",
    description: "Actions for canvas/block manipulation",
  });

  // Register element actions
  contextMenuActionRegistry.registerActions(elementActionHandlerMap, {
    category: "element",
    description: "Actions for element manipulation",
  });

  // Register group actions
  contextMenuActionRegistry.registerActions(groupActionHandlerMap, {
    category: "group",
    description: "Actions for group manipulation",
  });

  // Register add element actions
  contextMenuActionRegistry.registerActions(addElementActionHandlerMap, {
    category: "add-element",
    description: "Actions for adding new elements",
  });

  return contextMenuActionRegistry;
};

/**
 * Unregister all stage actions (useful for cleanup or testing)
 */
export const unregisterStageActions = () => {
  // Unregister actions from each handler map
  [
    ...Object.keys(sharedActionHandlerMap),
    ...Object.keys(canvasActionHandlerMap),
    ...Object.keys(elementActionHandlerMap),
    ...Object.keys(groupActionHandlerMap),
    ...Object.keys(addElementActionHandlerMap),
  ].forEach((actionName) => {
    contextMenuActionRegistry.unregisterAction(actionName);
  });
};

// Auto-register on import (can be disabled if needed)
if (typeof window !== "undefined") {
  registerStageActions();
}
